const HELP_LINKS_LIST = {
  '/toolset/dataset': 'https://help.cengage.com/salt/?t=dataset',
  '/toolset/descriptive-statistics': 'https://help.cengage.com/salt/?t=descriptive',
  '/toolset/charts-and-graphs': 'https://help.cengage.com/salt/?t=graphs',
  '/toolset/distributions': 'https://help.cengage.com/salt/?t=distributions',
  '/toolset/lite': 'https://help.cengage.com/salt/?t=distributions',
  '/toolset/sampling-distributions': 'https://help.cengage.com/salt/?t=sampling',
  '/toolset/inferential-statistics': 'https://help.cengage.com/salt/?t=inferential',
  '/toolset/bootstrap-confidence-intervals': 'https://help.cengage.com/salt/?t=ci',
  '/toolset/randomization-hypothesis-testing': 'https://help.cengage.com/salt/?t=hypothesis',
  '/toolset/regression': 'https://help.cengage.com/salt/?t=regression'
};

export default HELP_LINKS_LIST;
